/* myHarry VIP Sale – Landingpage
   - Kategorie-Auswahl (Kacheln) -> zeigt die passende Variante der Landingpage
   - Countdown
   - Klaviyo-Anmeldung in 2 Schritten (E-Mail, danach optional Handynummer)
   Keine Abhängigkeiten. */
(function () {
  'use strict';

function boot() {
  var root = document.querySelector('[data-vip]');
  if (!root || root.__vipInit) return;
  root.__vipInit = true;

  var cfg = {
    deadline: root.getAttribute('data-deadline'),
    company: (root.getAttribute('data-klaviyo-company') || '').trim(),
    list: (root.getAttribute('data-klaviyo-list') || '').trim(),
    smsConsent: root.getAttribute('data-sms-consent') === 'true',
    source: root.getAttribute('data-source') || 'VIP Sale Landingpage',
    defaultAccent: root.getAttribute('data-accent') || '#d27437',
    remember: root.getAttribute('data-remember') !== 'false',
    designMode: root.getAttribute('data-design-mode') === 'true'
  };

  var KEY_THEME = 'mh_vip_theme';
  var KEY_STATE = 'mh_vip_state';

  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* ---------------- Thema / Kategorie ---------------- */
  var picker = root.querySelector('[data-vip-picker]');
  var landing = root.querySelector('[data-vip-landing]');
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-vip-pick]'));
  var keys = tiles.map(function (t) { return t.getAttribute('data-vip-pick'); });
  var current = null;

  function showTheme(key, opts) {
    opts = opts || {};
    if (keys.indexOf(key) === -1) return showPicker(opts);
    current = key;
    var tile = root.querySelector('[data-vip-pick="' + key + '"]');
    root.style.setProperty('--vip-accent', (tile && tile.getAttribute('data-accent')) || cfg.defaultAccent);
    root.querySelectorAll('[data-vip-variant]').forEach(function (el) {
      el.hidden = el.getAttribute('data-vip-variant') !== key;
    });
    picker.hidden = !cfg.designMode && true;
    landing.hidden = false;
    // Animation neu starten
    landing.classList.remove('vip-landing'); void landing.offsetWidth; landing.classList.add('vip-landing');
    if (cfg.remember) store(KEY_THEME, key);
    if (opts.push !== false) updateUrl(key);
    if (opts.scroll !== false) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    track('VIP Sale Thema gewählt', { thema: key });
  }

  function showPicker(opts) {
    opts = opts || {};
    current = null;
    root.style.setProperty('--vip-accent', cfg.defaultAccent);
    landing.hidden = !cfg.designMode;
    picker.hidden = false;
    if (opts.push !== false) updateUrl(null);
    if (opts.scroll !== false) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function updateUrl(key) {
    try {
      var url = new URL(window.location.href);
      if (key) url.searchParams.set('thema', key); else url.searchParams.delete('thema');
      history.pushState({ vipTheme: key }, '', url.toString());
    } catch (e) {}
  }

  tiles.forEach(function (t) {
    t.addEventListener('click', function (e) { e.preventDefault(); showTheme(t.getAttribute('data-vip-pick')); });
  });
  root.querySelectorAll('[data-vip-switch]').forEach(function (b) {
    b.addEventListener('click', function () { showPicker(); });
  });
  window.addEventListener('popstate', function () {
    var k = new URLSearchParams(window.location.search).get('thema');
    if (k) showTheme(k, { push: false, scroll: false }); else showPicker({ push: false, scroll: false });
  });

  // Startzustand: ?thema= in der URL > gespeicherte Wahl > Auswahlseite
  (function init() {
    var fromUrl = new URLSearchParams(window.location.search).get('thema');
    var saved = cfg.remember && !cfg.designMode ? load(KEY_THEME) : null;
    var start = fromUrl || saved;
    if (start && keys.indexOf(start) > -1) showTheme(start, { push: false, scroll: false });
    else if (cfg.designMode && keys.length) showTheme(keys[0], { push: false, scroll: false });
    else showPicker({ push: false, scroll: false });
  })();

  /* ---------------- Countdown ---------------- */
  // Akzeptiert ISO (2026-10-25T00:00:00+02:00), "2026-10-25 00:00" oder "25.10.2026 00:00"
  // Ohne Zeitzonenangabe gilt die Zeit des Besuchers.
  function parseDeadline(v) {
    v = String(v || '').trim();
    var m = v.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ ,T]+(\d{1,2}):(\d{2}))?$/);
    if (m) return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0)).getTime();
    var t = Date.parse(v.replace(' ', 'T'));
    return isNaN(t) ? Date.parse(v) : t;
  }
  var target = parseDeadline(cfg.deadline);
  if (isNaN(target)) console.warn('[VIP Sale] Countdown-Datum nicht lesbar:', cfg.deadline);
  var cdEls = root.querySelectorAll('[data-vip-cd]');
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    if (isNaN(target)) return;
    var diff = Math.max(0, target - Date.now());
    var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24,
        m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
    cdEls.forEach(function (el) {
      var set = function (u, v) { var n = el.querySelector('[data-u="' + u + '"]'); if (n) n.textContent = v; };
      set('d', pad(d)); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
      var done = el.querySelector('[data-vip-cd-done]'), run = el.querySelector('[data-vip-cd-run]');
      if (done && run) { done.hidden = diff > 0; run.hidden = diff === 0; }
    });
    if (diff === 0) clearInterval(timer);
  }
  if (window.__vipTimer) clearInterval(window.__vipTimer);
  var timer = window.__vipTimer = setInterval(tick, 1000); tick();

  /* ---------------- Anmeldung (Klaviyo) ---------------- */
  // Zustand: '' = noch nicht angemeldet, 'email' = E-Mail da, 'done' = fertig (mit oder ohne Handy)
  var state = { step: load(KEY_STATE) || '', email: load(KEY_STATE + '_email') || '' };
  if (cfg.designMode) state = { step: '', email: '' };

  function setStep(step) {
    state.step = step;
    if (!cfg.designMode) {
      store(KEY_STATE, step || null);
      store(KEY_STATE + '_email', state.email || null);
    }
    render();
  }

  function render() {
    root.querySelectorAll('[data-vip-form]').forEach(function (f) {
      f.querySelector('[data-step="email"]').hidden = state.step !== '';
      f.querySelector('[data-step="phone"]').hidden = state.step !== 'email';
      f.querySelector('[data-step="done"]').hidden = state.step !== 'done';
    });
    root.querySelectorAll('[data-vip-sms-cta]').forEach(function (el) { el.hidden = state.step === 'done'; });
    root.querySelectorAll('[data-vip-sms-done]').forEach(function (el) { el.hidden = state.step !== 'done'; });
  }

  function normalizePhone(prefix, raw) {
    var p = String(raw || '').replace(/[^\d+]/g, '');
    if (!p) return '';
    if (p.indexOf('00') === 0) p = '+' + p.slice(2);
    if (p.charAt(0) !== '+') p = prefix + p.replace(/^0+/, '');
    return /^\+\d{8,15}$/.test(p) ? p : null;
  }

  function subscribe(payload) {
    if (!cfg.company || !cfg.list) {
      console.warn('[VIP Sale] Klaviyo Site-ID oder List-ID fehlt – Anmeldung wird nur simuliert.', payload);
      return new Promise(function (r) { setTimeout(r, 600); });
    }
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var attrs = { email: payload.email, subscriptions: subs };
    if (payload.phone) {
      attrs.phone_number = payload.phone;
      if (cfg.smsConsent) subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    var body = {
      data: {
        type: 'subscription',
        attributes: { custom_source: cfg.source, profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t || res.status); });
      // Profil-Eigenschaften (Interesse, Quelle) separat setzen
      return setProfileProperties(payload);
    });
  }

  function setProfileProperties(payload) {
    var props = {
      vip_sale_interesse: current || '',
      vip_sale_quelle: cfg.source,
      vip_sale_anmeldung: new Date().toISOString()
    };
    if (payload.phone) props.vip_sale_handy_bonus = true;
    var attrs = { email: payload.email, properties: props };
    return fetch('https://a.klaviyo.com/client/profiles?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify({ data: { type: 'profile', attributes: attrs } })
    }).catch(function () { /* nicht kritisch */ });
  }

  function track(name, props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track(name, props);
    } catch (e) {}
  }

  function showError(form, msg) {
    var e = form.querySelector('.vip-form__error');
    e.textContent = msg; e.hidden = !msg;
  }

  function busy(btn, on) { if (!btn) return; btn.disabled = on; }

  root.querySelectorAll('[data-vip-form]').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      showError(form, '');
      var btn = form.querySelector('[data-step]:not([hidden]) button[type=submit]');

      if (state.step === '') {
        var email = (form.querySelector('input[type=email]').value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return showError(form, 'Bitte gib eine gültige E-Mail-Adresse ein.');
        busy(btn, true);
        subscribe({ email: email }).then(function () {
          state.email = email;
          setStep('email');
          track('VIP Sale Anmeldung', { thema: current || '' });
        }).catch(function (err) {
          console.error('[VIP Sale]', err);
          showError(form, 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.');
        }).then(function () { busy(btn, false); });
        return;
      }

      if (state.step === 'email') {
        var prefix = (form.querySelector('select[name=prefix]') || {}).value || '+49';
        var phone = normalizePhone(prefix, form.querySelector('input[type=tel]').value);
        if (!phone) return showError(form, 'Bitte gib eine gültige Handynummer ein.');
        var consent = form.querySelector('input[name=sms_consent]');
        if (consent && !consent.checked) return showError(form, 'Bitte bestätige die Einwilligung.');
        busy(btn, true);
        subscribe({ email: state.email, phone: phone }).then(function () {
          setStep('done');
          track('VIP Sale Handy-Bonus', { thema: current || '' });
        }).catch(function (err) {
          console.error('[VIP Sale]', err);
          showError(form, 'Die Nummer konnte nicht gespeichert werden. Bitte prüfe sie und versuch es erneut.');
        }).then(function () { busy(btn, false); });
      }
    });
  });

  root.querySelectorAll('[data-vip-skip]').forEach(function (b) {
    b.addEventListener('click', function () { setStep('done'); });
  });

  // "Extra-Rabatt sichern"-Button scrollt zum Hero-Formular
  root.querySelectorAll('[data-vip-scroll-form]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = root.querySelector('[data-vip-variant="' + current + '"] [data-vip-form]') || root.querySelector('[data-vip-form]');
      if (!f) return;
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = f.querySelector('[data-step]:not([hidden]) input');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
    });
  });

  render();

  // Theme-Editor: Kategorie-Block anklicken -> passende Variante zeigen
  if (cfg.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      var k = e.target && e.target.getAttribute && e.target.getAttribute('data-vip-pick');
      if (k && root.isConnected) showTheme(k, { push: false, scroll: false });
    });
  }
}

  boot();
  document.addEventListener('shopify:section:load', boot);
})();
